<template>
  <v-dialog fullscreen persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">New/Edit Role</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field hide-details v-model="form.role_name" label="Role name" color="black"></v-text-field>
          <v-card v-for="(info_province,index_province) in mocking_province" :key="index_province">
            <v-card-title>
              <v-flex xs4>
                <v-select
                  :items="[{name : 'Phuket',value : 1},{name : 'Surat',value : 1}]"
                  :label=" 'Province delivery'"
                  item-text="name"
                  item-value="value"
                  hide-details
                ></v-select>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-card-title>
                  <v-checkbox
                    v-model="ex_service"
                    label="Order dashboard"
                    color="green"
                    value="1"
                    hide-details
                  ></v-checkbox>
                </v-card-title>
                <v-card-text>
                  <v-radio-group>
                    <v-radio label="Read only"></v-radio>
                    <v-radio label="Read/Write"></v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-text>
              <v-card>
                <v-card-title>
                  <v-checkbox
                    v-model="ex_service"
                    label="Control dashboard"
                    color="green"
                    value="1"
                    hide-details
                  ></v-checkbox>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex
                      xs2
                      sm2
                      md2
                      v-for="(info,index) in mocking_service"
                      :key="index"
                      class="mb-2 pr-2"
                    >
                      <v-card>
                        <v-card-title>
                          <v-checkbox
                            v-model="ex_service"
                            :label="info.name"
                            color="green"
                            value="1"
                            hide-details
                          ></v-checkbox>
                        </v-card-title>
                        <v-card-text>
                          <v-radio-group>
                            <v-radio label="Read only"></v-radio>
                            <v-radio label="Read/Write"></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="$emit('setDialog', false)">Cancel</v-btn>
        <v-btn color="green" flat>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog"],
  data() {
    return {
      headers: [
        {
          text: "Dessert (100g serving)",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Calories", value: "calories" },
        { text: "Fat (g)", value: "fat" },
        { text: "Carbs (g)", value: "carbs" },
        { text: "Protein (g)", value: "protein" },
        { text: "Iron (%)", value: "iron" }
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%"
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%"
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%"
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: "8%"
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: "16%"
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%"
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%"
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: "45%"
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: "22%"
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%"
        }
      ],
      valid: true,
      role_name: "",
      ex_service: ["1", "2", "3", "4"],
      mocking_service: [
        {
          id: 1,
          name: "Food delivery"
        },
        {
          id: 2,
          name: "Messenger"
        },
        {
          id: 3,
          name: "Point of sale"
        },
        {
          id: 4,
          name: "Rider"
        }
      ],
      mocking_province: [{ id: 1, name: "Phuket" }],
      form: {}
    };
  },
  created() {
    this.form = {
      role_id: 1,
      role_name: "root",
      provinces: [
        {
          province_id: 66,
          province_name: "phuket",
          dashboards: [
            {
              dashboard_id: 1,
              dashboard_name: "order",
              permission: "read"
            },
            {
              dashboard_id: 1,
              dashboard_name: "control_panel",
              services: [
                {
                  service_id: 1,
                  service_name: "Food Delivery",
                  permission: "read"
                },
                {
                  service_id: 2,
                  service_name: "Point of Sale",
                  permission: "read"
                },
                {
                  service_id: 3,
                  service_name: "Messenger",
                  permission: "read"
                },
                {
                  service_id: 4,
                  service_name: "Rider",
                  permission: "read"
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>





